import { cx } from "../../lib/index.js";
import { AutocompleteSubmitIcon } from "./icons.js";
export function createAutocompleteSuggestionComponent(_ref) {
  var createElement = _ref.createElement;
  return function AutocompleteSuggestion(_ref2) {
    var children = _ref2.children,
      onSelect = _ref2.onSelect,
      _ref2$classNames = _ref2.classNames,
      classNames = _ref2$classNames === void 0 ? {} : _ref2$classNames;
    return createElement("div", {
      onClick: onSelect,
      className: cx('ais-AutocompleteItemWrapper', 'ais-AutocompleteSuggestionWrapper', classNames.root)
    }, createElement("div", {
      className: cx('ais-AutocompleteItemContent', 'ais-AutocompleteSuggestionItemContent', classNames.content)
    }, createElement("div", {
      className: cx('ais-AutocompleteItemIcon', 'ais-AutocompleteSuggestionItemIcon', classNames.content)
    }, createElement(AutocompleteSubmitIcon, {
      createElement: createElement
    })), createElement("div", {
      className: cx('ais-AutocompleteItemContentBody', 'ais-AutocompleteSuggestionItemContentBody', classNames.content)
    }, children)));
  };
}